import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const clientRoutes: RouteConfig = {
  path: '/clients',
  component: Layout,
  redirect: 'noRedirect', // '/clients/list',
  name: 'Client',
  meta: {
    title: 'Client',
    icon: 'tree-table',
    roles: ['Admin']
  },

  children: [
    {
      path: 'list',
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/clients/index.vue'),
      name: 'Clients',
      meta: {
        title: 'listClients',
        icon: 'list',
        affix: false
      }
    },
    {
      path: 'create',
      component: () => import(/* webpackChunkName: "clients-create" */ '@/views/clients/create.vue'),
      name: 'CreateClient',
      meta: {
        title: 'createClient',
        icon: 'edit'
      }
    },
    {
      path: 'edit/:id(\\d+)',
      component: () => import(/* webpackChunkName: "clients-edit" */ '@/views/clients/edit.vue'),
      name: 'EditClient',
      meta: {
        title: 'editClient',
        noCache: true,
        activeMenu: '/clients/list',
        hidden: true
      }
    }
  ]
}

export default clientRoutes
